/* ============================================================================
FILE: po-pillars-quiz-texts-fr-en-es-20260321.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte
API:  window.PoPillarsQuizTextsFR_EN_ES_20260321
ROOT: .po-pillars-quiz-section[data-po-pillars-quiz="piliers_quiz"]

RÔLE:
- injecte le contenu FR/EN/ES du quiz des Piliers
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- conserve la logique score / réponses / compteur
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_PILLARS_QUIZ_TEXTS_20260321__) return;
  window.__PO_PILLARS_QUIZ_TEXTS_20260321__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-pillars-quiz-section[data-po-pillars-quiz="piliers_quiz"]';
  var COUNTER_KEY = "poso_counts";

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function syncDocumentLang(lang) {
    try {
      document.documentElement.setAttribute("lang", lang || "fr");
    } catch (e) {}
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);
    uniqPush(out, t.replace(/’/g, "'"));
    uniqPush(out, t.replace(/'/g, "’"));
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"));
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"));
    return out;
  }

  function getSimplifiedLexiqueFRList() {
    var merged = [];
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        for (var i = 0; i < window.PO_LEXICON_META.lexique_simplifie_fr.length; i++) {
          uniqPush(merged, window.PO_LEXICON_META.lexique_simplifie_fr[i]);
        }
      }
    } catch (e) {}

    [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Organon posœnnoïal",
      "Katûvýs",
      "Katûvýsissence",
      "RéZonans",
      "Péroptissimisme",
      "Illusion",
      "Aliœvolution",
      "Addition synchrêtique",
      "Superposition de perspectives",
      "Instantané multiple",
      "Sujet pluriel",
      "Posœnnoïamie",
      "Posœnnomia",
      "Temporalité élargie",
      "Temporalité éclatée"
    ].forEach(function (term) {
      uniqPush(merged, term);
    });

    return merged;
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }

    variants.sort(function (a, b) { return b.length - a.length; });

    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }

    return new RegExp(parts.join("|"), "g");
  }

  function protectLexiconInHTML(html) {
    var src = clampStr(html);
    if (!src) return "";
    var rx = buildProtectMatcher();
    return src.replace(rx, function (m) {
      return '<span translate="no" class="po-lex-protect">' + m + "</span>";
    });
  }

  function setHTML(el, html) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setText(el, txt) {
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setImg(el, data) {
    if (!el) return;
    var src = data && data.src ? data.src : "";
    var alt = data && data.alt ? data.alt : "";
    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
    } else {
      el.setAttribute("hidden", "");
    }
  }

  function loadCounter() {
    try {
      return JSON.parse(localStorage.getItem(COUNTER_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function saveCounter(data) {
    try {
      localStorage.setItem(COUNTER_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function bump(path) {
    if (!path) return;
    var data = loadCounter();
    var keys = String(path).split(".");
    var ref = data;

    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (i === keys.length - 1) {
        ref[k] = (ref[k] || 0) + 1;
      } else {
        ref[k] = ref[k] || {};
        ref = ref[k];
      }
    }

    saveCounter(data);

    try {
      window.dispatchEvent(new StorageEvent("storage", {
        key: COUNTER_KEY,
        newValue: JSON.stringify(data)
      }));
    } catch (e) {}
  }

  var UI = {
    fr: {
      langbar_aria: "Langue",
      sections_aria: "Piliers du quiz",
      submit_cta: "Afficher le score",
      warning_incomplete: "Merci de répondre à toutes les questions avant d’afficher le score.",
      toggle_answers_show: "👉 Voir les bonnes réponses",
      toggle_answers_hide: "👉 Masquer les bonnes réponses",
      cta_translate: "Proposer une traduction du concept",
      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Pilliers_posoenoiaux_2.png?v=1746290111",
        alt: "Idéogramme des Piliers posœnnoïaux"
      },
      tabs: {
        rezonans: "RéZonans",
        peroptissimisme: "Péroptissimisme",
        illusion: "Illusion",
        alioevolution: "Aliœvolution"
      },
      sections: {
        rezonans: {
          title: "Quiz – Pilier « RéZonans »",
          kicker: "Ajustement vibratoire de l’être en interaction avec l’environnement."
        },
        peroptissimisme: {
          title: "Quiz – Pilier « Péroptissimisme »",
          kicker: "Tension féconde de lucidité, relance, endurance et transmutation."
        },
        illusion: {
          title: "Quiz – Pilier « Illusion »",
          kicker: "Interface entre réel, imaginaire et perception vibratoire."
        },
        alioevolution: {
          title: "Quiz – Pilier « Aliœvolution »",
          kicker: "Transformation enracinée dans l’altérité et dans le temps du devenir."
        }
      },
      scoreText: function (score, total) {
        return "✨ Vous avez obtenu <strong>" + score + "/" + total + "</strong> bonnes réponses.";
      }
    },

    en: {
      langbar_aria: "Language",
      sections_aria: "Quiz pillars",
      submit_cta: "Show the score",
      warning_incomplete: "Please answer every question before showing the score.",
      toggle_answers_show: "👉 View the correct answers",
      toggle_answers_hide: "👉 Hide the correct answers",
      cta_translate: "Proposer une traduction du concept",
      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Pilliers_posoenoiaux_2.png?v=1746290111",
        alt: "Ideogram of the Posœnnoïal Pillars"
      },
      tabs: {
        rezonans: "RéZonans",
        peroptissimisme: "Péroptissimisme",
        illusion: "Illusion",
        alioevolution: "Aliœvolution"
      },
      sections: {
        rezonans: {
          title: "Quiz – Pillar “RéZonans”",
          kicker: "Vibratory adjustment of the being in interaction with the environment."
        },
        peroptissimisme: {
          title: "Quiz – Pillar “Péroptissimisme”",
          kicker: "Fecund tension of lucidity, relaunch, endurance, and transmutation."
        },
        illusion: {
          title: "Quiz – Pillar “Illusion”",
          kicker: "Interface between the real, the imaginary, and vibratory perception."
        },
        alioevolution: {
          title: "Quiz – Pillar “Aliœvolution”",
          kicker: "Rooted transformation through alterity and through the time of becoming."
        }
      },
      scoreText: function (score, total) {
        return "✨ You scored <strong>" + score + "/" + total + "</strong> correct answers.";
      }
    },

    es: {
      langbar_aria: "Idioma",
      sections_aria: "Pilares del quiz",
      submit_cta: "Mostrar la puntuación",
      warning_incomplete: "Gracias por responder a todas las preguntas antes de mostrar la puntuación.",
      toggle_answers_show: "👉 Ver las respuestas correctas",
      toggle_answers_hide: "👉 Ocultar las respuestas correctas",
      cta_translate: "Proposer une traduction du concept",
      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Pilliers_posoenoiaux_2.png?v=1746290111",
        alt: "Ideograma de los Pilares posœnnoïaux"
      },
      tabs: {
        rezonans: "RéZonans",
        peroptissimisme: "Péroptissimisme",
        illusion: "Illusion",
        alioevolution: "Aliœvolution"
      },
      sections: {
        rezonans: {
          title: "Quiz – Pilar « RéZonans »",
          kicker: "Ajuste vibratorio del ser en interacción con el entorno."
        },
        peroptissimisme: {
          title: "Quiz – Pilar « Péroptissimisme »",
          kicker: "Tensión fecunda de lucidez, relanzamiento, resistencia y transmutación."
        },
        illusion: {
          title: "Quiz – Pilar « Illusion »",
          kicker: "Interfaz entre lo real, lo imaginario y la percepción vibratoria."
        },
        alioevolution: {
          title: "Quiz – Pilar « Aliœvolution »",
          kicker: "Transformación enraizada en la alteridad y en el tiempo del devenir."
        }
      },
      scoreText: function (score, total) {
        return "✨ Ha obtenido <strong>" + score + "/" + total + "</strong> respuestas correctas.";
      }
    }
  };

  var BANK = {
    rezonans: [
      {
        ans: "c",
        q: {
          fr: "Quelle est la vocation première de la RéZonans dans l’Organon posœnnoïal ?",
          en: "What is the primary vocation of RéZonans within the Organon posœnnoïal?",
          es: "¿Cuál es la vocación primera de RéZonans en el Organon posœnnoïal?"
        },
        options: {
          a: { fr: "Remplacer les autres piliers", en: "To replace the other pillars", es: "Reemplazar los otros pilares" },
          b: { fr: "Créer une hiérarchie de savoirs", en: "To create a hierarchy of knowledge", es: "Crear una jerarquía de saberes" },
          c: { fr: "Mettre en syntonie l’individu avec son environnement, ses mémoires et son souffle", en: "To bring the individual into syntony with environment, memories, and breath", es: "Poner al individuo en sintonía con su entorno, sus memorias y su aliento" },
          d: { fr: "Fixer une tradition immobile", en: "To fix an immobile tradition", es: "Fijar una tradición inmóvil" }
        }
      },
      {
        ans: "c",
        q: {
          fr: "Quel élément est associé à la RéZonans ?",
          en: "Which element is associated with RéZonans?",
          es: "¿Qué elemento se asocia a RéZonans?"
        },
        options: {
          a: { fr: "Feu", en: "Fire", es: "Fuego" },
          b: { fr: "Eau", en: "Water", es: "Agua" },
          c: { fr: "Air", en: "Air", es: "Aire" },
          d: { fr: "Éther", en: "Ether", es: "Éter" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Quel est le totem de la RéZonans ?",
          en: "What is the totem of RéZonans?",
          es: "¿Cuál es el tótem de RéZonans?"
        },
        options: {
          a: { fr: "Phénix", en: "Phoenix", es: "Fénix" },
          b: { fr: "Libellule", en: "Dragonfly", es: "Libélula" },
          c: { fr: "Arbre", en: "Tree", es: "Árbol" },
          d: { fr: "Sirène", en: "Mermaid", es: "Sirena" }
        }
      },
      {
        ans: "d",
        q: {
          fr: "Quel est le nombre-guide de la RéZonans ?",
          en: "What is the guide-number of RéZonans?",
          es: "¿Cuál es el número-guía de RéZonans?"
        },
        options: {
          a: { fr: "4", en: "4", es: "4" },
          b: { fr: "6", en: "6", es: "6" },
          c: { fr: "11", en: "11", es: "11" },
          d: { fr: "22", en: "22", es: "22" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Le mot « RéZonans » convoque « rézon ». Que porte ce mot ?",
          en: "The word “RéZonans” summons “rézon.” What does this word carry?",
          es: "La palabra « RéZonans » convoca « rézon ». ¿Qué porta esta palabra?"
        },
        options: {
          a: { fr: "Simple décor sonore", en: "A simple sonic ornament", es: "Un simple adorno sonoro" },
          b: { fr: "Logique intuitive et raison élargie", en: "Intuitive logic and expanded reason", es: "Lógica intuitiva y razón ampliada" },
          c: { fr: "Un emprunt kabbalistique direct", en: "A direct kabbalistic borrowing", es: "Un préstamo cabalístico directo" },
          d: { fr: "Une onomatopée", en: "An onomatopoeia", es: "Una onomatopeya" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Dans la RéZonans, « RéZoindre » signifie :",
          en: "In RéZonans, “RéZoindre” means:",
          es: "En RéZonans, « RéZoindre » significa:"
        },
        options: {
          a: { fr: "Se dissoudre dans l’autre", en: "To dissolve into the other", es: "Disolverse en el otro" },
          b: { fr: "Relier sans confondre", en: "To connect without confusing", es: "Vincular sin confundir" },
          c: { fr: "Imposer une unité", en: "To impose a unity", es: "Imponer una unidad" },
          d: { fr: "Clore la vibration", en: "To close vibration", es: "Cerrar la vibración" }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Dans les rapports humains, la RéZonans permet de :",
          en: "In human relations, RéZonans makes it possible to:",
          es: "En las relaciones humanas, RéZonans permite:"
        },
        options: {
          a: { fr: "Maintenir ensemble les différences", en: "Hold differences together", es: "Mantener juntas las diferencias" },
          b: { fr: "Supprimer les désaccords", en: "Suppress disagreements", es: "Suprimir los desacuerdos" },
          c: { fr: "Figer les identités", en: "Freeze identities", es: "Fijar las identidades" },
          d: { fr: "Remplacer la création", en: "Replace creation", es: "Reemplazar la creación" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Les capitales « R » et « Z » indiquent :",
          en: "The capital letters “R” and “Z” indicate:",
          es: "Las mayúsculas « R » y « Z » indican:"
        },
        options: {
          a: { fr: "Un hasard", en: "A coincidence", es: "Un azar" },
          b: { fr: "Une intention symbolique et énergétique", en: "A symbolic and energetic intention", es: "Una intención simbólica y energética" },
          c: { fr: "Un code binaire", en: "A binary code", es: "Un código binario" },
          d: { fr: "Une référence latine", en: "A Latin reference", es: "Una referencia latina" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "La RéZonans se situe :",
          en: "RéZonans is situated:",
          es: "RéZonans se sitúa:"
        },
        options: {
          a: { fr: "Comme commentaire critique", en: "As a critical commentary", es: "Como comentario crítico" },
          b: { fr: "Comme lieu d’allers-retours vibratoires", en: "As a place of vibratory back-and-forth", es: "Como lugar de idas y vueltas vibratorias" },
          c: { fr: "Comme outil unique du temps", en: "As the sole tool of time", es: "Como herramienta única del tiempo" },
          d: { fr: "Comme artefact externe", en: "As an external artifact", es: "Como artefacto externo" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Pourquoi la libellule ?",
          en: "Why the dragonfly?",
          es: "¿Por qué la libélula?"
        },
        options: {
          a: { fr: "Car immobile", en: "Because it is immobile", es: "Porque es inmóvil" },
          b: { fr: "Passage léger multidirectionnel dans la lumière", en: "A light multidirectional passage through light", es: "Paso ligero multidireccional en la luz" },
          c: { fr: "Animal nocturne", en: "A nocturnal animal", es: "Animal nocturno" },
          d: { fr: "Symbole du secret", en: "A symbol of secrecy", es: "Símbolo del secreto" }
        }
      }
    ],

    peroptissimisme: [
      {
        ans: "b",
        q: {
          fr: "Le Péroptissimisme est :",
          en: "Péroptissimisme is:",
          es: "Péroptissimisme es:"
        },
        options: {
          a: { fr: "Un refus de critique", en: "A refusal of critique", es: "Un rechazo de la crítica" },
          b: { fr: "Fusion vivante pessimisme / réalisme / optimisme / espoir", en: "A living fusion of pessimism / realism / optimism / hope", es: "Fusión viva de pesimismo / realismo / optimismo / esperanza" },
          c: { fr: "Un style d’écriture", en: "A writing style", es: "Un estilo de escritura" },
          d: { fr: "Une attitude psychologique", en: "A psychological attitude", es: "Una actitud psicológica" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Quel élément est associé au Péroptissimisme ?",
          en: "Which element is associated with Péroptissimisme?",
          es: "¿Qué elemento se asocia a Péroptissimisme?"
        },
        options: {
          a: { fr: "Air", en: "Air", es: "Aire" },
          b: { fr: "Feu", en: "Fire", es: "Fuego" },
          c: { fr: "Eau", en: "Water", es: "Agua" },
          d: { fr: "Terre", en: "Earth", es: "Tierra" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Quel est son totem ?",
          en: "What is its totem?",
          es: "¿Cuál es su tótem?"
        },
        options: {
          a: { fr: "Libellule", en: "Dragonfly", es: "Libélula" },
          b: { fr: "Phénix", en: "Phoenix", es: "Fénix" },
          c: { fr: "Sirène", en: "Mermaid", es: "Sirena" },
          d: { fr: "Arbre", en: "Tree", es: "Árbol" }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Quel est son nombre-guide ?",
          en: "What is its guide-number?",
          es: "¿Cuál es su número-guía?"
        },
        options: {
          a: { fr: "11", en: "11", es: "11" },
          b: { fr: "22", en: "22", es: "22" },
          c: { fr: "6", en: "6", es: "6" },
          d: { fr: "4", en: "4", es: "4" }
        }
      },
      {
        ans: "c",
        q: {
          fr: "Il crée un espace où se rencontrent :",
          en: "It creates a space where the following meet:",
          es: "Crea un espacio donde se encuentran:"
        },
        options: {
          a: { fr: "Seulement l’espoir", en: "Only hope", es: "Solo la esperanza" },
          b: { fr: "Des contraires sans transformation", en: "Opposites without transformation", es: "Contrarios sin transformación" },
          c: { fr: "Analyse rationnelle et foi en l’évolution", en: "Rational analysis and faith in evolution", es: "Análisis racional y fe en la evolución" },
          d: { fr: "Mémoire et oubli", en: "Memory and forgetting", es: "Memoria y olvido" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Ce pilier agit comme :",
          en: "This pillar acts as:",
          es: "Este pilar actúa como:"
        },
        options: {
          a: { fr: "Résignation lucide", en: "Lucid resignation", es: "Resignación lúcida" },
          b: { fr: "Moteur de déconstruction–reconstruction", en: "A motor of deconstruction–reconstruction", es: "Motor de deconstrucción–reconstrucción" },
          c: { fr: "Refus de complexité", en: "A refusal of complexity", es: "Rechazo de la complejidad" },
          d: { fr: "Retour au passé", en: "A return to the past", es: "Retorno al pasado" }
        }
      },
      {
        ans: "c",
        q: {
          fr: "Pourquoi le Phénix est-il cohérent avec ce pilier ?",
          en: "Why is the Phoenix coherent with this pillar?",
          es: "¿Por qué el Fénix es coherente con este pilar?"
        },
        options: {
          a: { fr: "Car il vit sous l’eau", en: "Because it lives under water", es: "Porque vive bajo el agua" },
          b: { fr: "Car il renonce à renaître", en: "Because it refuses rebirth", es: "Porque renuncia a renacer" },
          c: { fr: "Car il figure la renaissance après brûlure", en: "Because it figures rebirth after burning", es: "Porque figura el renacimiento tras la quemadura" },
          d: { fr: "Car il reste neutre", en: "Because it remains neutral", es: "Porque permanece neutro" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Le segment « -issim- » indique surtout :",
          en: "The segment “-issim-” chiefly indicates:",
          es: "El segmento « -issim- » indica sobre todo:"
        },
        options: {
          a: { fr: "Un effet décoratif", en: "A decorative effect", es: "Un efecto decorativo" },
          b: { fr: "Un superlatif, une tension vers l’intensité", en: "A superlative, a tension toward intensity", es: "Un superlativo, una tensión hacia la intensidad" },
          c: { fr: "Une référence grecque", en: "A Greek reference", es: "Una referencia griega" },
          d: { fr: "Une formule numérique", en: "A numerical formula", es: "Una fórmula numérica" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Ce pilier donne une place essentielle à l’humain pour :",
          en: "This pillar gives an essential place to the human in order to:",
          es: "Este pilar da un lugar esencial a lo humano para:"
        },
        options: {
          a: { fr: "Se retirer", en: "Withdraw", es: "Retirarse" },
          b: { fr: "Agir dans l’altération du monde", en: "Act within the alteration of the world", es: "Actuar en la alteración del mundo" },
          c: { fr: "Refuser l’évolution", en: "Refuse evolution", es: "Rechazar la evolución" },
          d: { fr: "Réduire le corpus", en: "Reduce the corpus", es: "Reducir el corpus" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Il se situe comme :",
          en: "It is situated as:",
          es: "Se sitúa como:"
        },
        options: {
          a: { fr: "Filtre morose", en: "A morose filter", es: "Filtro sombrío" },
          b: { fr: "Feu d’ajustement lucide", en: "A fire of lucid adjustment", es: "Fuego de ajuste lúcido" },
          c: { fr: "Loi morale", en: "A moral law", es: "Ley moral" },
          d: { fr: "Appendice", en: "An appendix", es: "Apéndice" }
        }
      }
    ],

    illusion: [
      {
        ans: "b",
        q: {
          fr: "L’Illusion est surtout :",
          en: "Illusion is above all:",
          es: "Illusion es sobre todo:"
        },
        options: {
          a: { fr: "Une tromperie à bannir", en: "A deception to banish", es: "Un engaño a desterrar" },
          b: { fr: "Une fluctuation active entre perception et réalité", en: "An active fluctuation between perception and reality", es: "Una fluctuación activa entre percepción y realidad" },
          c: { fr: "Une image poétique", en: "A poetic image", es: "Una imagen poética" },
          d: { fr: "Un outil juridique", en: "A legal tool", es: "Una herramienta jurídica" }
        }
      },
      {
        ans: "c",
        q: {
          fr: "Quel élément est associé à l’Illusion ?",
          en: "Which element is associated with Illusion?",
          es: "¿Qué elemento se asocia a Illusion?"
        },
        options: {
          a: { fr: "Feu", en: "Fire", es: "Fuego" },
          b: { fr: "Air", en: "Air", es: "Aire" },
          c: { fr: "Eau", en: "Water", es: "Agua" },
          d: { fr: "Terre", en: "Earth", es: "Tierra" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Quel est son totem ?",
          en: "What is its totem?",
          es: "¿Cuál es su tótem?"
        },
        options: {
          a: { fr: "Libellule", en: "Dragonfly", es: "Libélula" },
          b: { fr: "Sirène", en: "Mermaid", es: "Sirena" },
          c: { fr: "Phénix", en: "Phoenix", es: "Fénix" },
          d: { fr: "Arbre", en: "Tree", es: "Árbol" }
        }
      },
      {
        ans: "c",
        q: {
          fr: "Quel est son nombre-guide ?",
          en: "What is its guide-number?",
          es: "¿Cuál es su número-guía?"
        },
        options: {
          a: { fr: "22", en: "22", es: "22" },
          b: { fr: "11", en: "11", es: "11" },
          c: { fr: "6", en: "6", es: "6" },
          d: { fr: "4", en: "4", es: "4" }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Ce pilier invite à :",
          en: "This pillar invites one to:",
          es: "Este pilar invita a:"
        },
        options: {
          a: { fr: "Voir le multiple-pluriel", en: "See the multiple-plural", es: "Ver lo múltiple-plural" },
          b: { fr: "Réduire à un point de vue", en: "Reduce to one point of view", es: "Reducir a un punto de vista" },
          c: { fr: "Annuler les piliers", en: "Cancel the pillars", es: "Anular los pilares" },
          d: { fr: "Sortir du sensible", en: "Leave the sensible", es: "Salir de lo sensible" }
        }
      },
      {
        ans: "c",
        q: {
          fr: "Pourquoi la Sirène ?",
          en: "Why the Mermaid?",
          es: "¿Por qué la Sirena?"
        },
        options: {
          a: { fr: "Pour le désert", en: "For the desert", es: "Por el desierto" },
          b: { fr: "Parce qu’elle est muette", en: "Because it is mute", es: "Porque es muda" },
          c: { fr: "Pour le miroir, le chant et les passages d’eau", en: "For mirror, song, and passages of water", es: "Por el espejo, el canto y los pasos de agua" },
          d: { fr: "Pour la sécheresse", en: "For dryness", es: "Por la sequedad" }
        }
      },
      {
        ans: "a",
        q: {
          fr: "L’Illusion permet de :",
          en: "Illusion makes it possible to:",
          es: "Illusion permite:"
        },
        options: {
          a: { fr: "Questionner les prismes", en: "Question prisms", es: "Cuestionar los prismas" },
          b: { fr: "Supprimer la subjectivité", en: "Suppress subjectivity", es: "Suprimir la subjetividad" },
          c: { fr: "Ne plus créer", en: "Create no longer", es: "Dejar de crear" },
          d: { fr: "Achever le système", en: "Bring the system to an end", es: "Terminar el sistema" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Elle n’est pas une « simple tromperie » car elle est :",
          en: "It is not a “simple deception” because it is:",
          es: "No es una « simple ilusión engañosa » porque es:"
        },
        options: {
          a: { fr: "Vide de sens", en: "Empty of meaning", es: "Vacía de sentido" },
          b: { fr: "Une interface mouvante qui ouvre d’autres sens", en: "A moving interface that opens other meanings", es: "Una interfaz móvil que abre otros sentidos" },
          c: { fr: "Le remplacement de la Katûvýs", en: "A replacement of Katûvýs", es: "El reemplazo de Katûvýs" },
          d: { fr: "Un abandon de l’image", en: "An abandonment of the image", es: "Un abandono de la imagen" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Ce pilier aide à travailler :",
          en: "This pillar helps one work on:",
          es: "Este pilar ayuda a trabajar:"
        },
        options: {
          a: { fr: "La fixité des identités", en: "The fixity of identities", es: "La fijeza de las identidades" },
          b: { fr: "La tension entre visible et invisible", en: "The tension between visible and invisible", es: "La tensión entre visible e invisible" },
          c: { fr: "La suppression des récits", en: "The suppression of narratives", es: "La supresión de los relatos" },
          d: { fr: "L’arrêt du temps", en: "The stopping of time", es: "La detención del tiempo" }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Dans les quatre piliers, l’Illusion :",
          en: "Within the four pillars, Illusion:",
          es: "Dentro de los cuatro pilares, Illusion:"
        },
        options: {
          a: { fr: "Complète les autres", en: "Complements the others", es: "Completa a los otros" },
          b: { fr: "S’oppose à RéZonans", en: "Opposes RéZonans", es: "Se opone a RéZonans" },
          c: { fr: "Annule Aliœvolution", en: "Cancels Aliœvolution", es: "Anula Aliœvolution" },
          d: { fr: "Remplace les engrenages", en: "Replaces the gears", es: "Reemplaza los engranajes" }
        }
      }
    ],

    alioevolution: [
      {
        ans: "b",
        q: {
          fr: "Quelle définition convient à l’Aliœvolution ?",
          en: "Which definition suits Aliœvolution?",
          es: "¿Qué definición conviene a Aliœvolution?"
        },
        options: {
          a: { fr: "Évolution solitaire", en: "Solitary evolution", es: "Evolución solitaria" },
          b: { fr: "Évolution avec et par l’altérité", en: "Evolution with and through alterity", es: "Evolución con y por la alteridad" },
          c: { fr: "Conservation identique", en: "Identical conservation", es: "Conservación idéntica" },
          d: { fr: "Pause du système", en: "A pause of the system", es: "Pausa del sistema" }
        }
      },
      {
        ans: "d",
        q: {
          fr: "Quel élément lui est associé ?",
          en: "Which element is associated with it?",
          es: "¿Qué elemento se le asocia?"
        },
        options: {
          a: { fr: "Air", en: "Air", es: "Aire" },
          b: { fr: "Feu", en: "Fire", es: "Fuego" },
          c: { fr: "Eau", en: "Water", es: "Agua" },
          d: { fr: "Terre", en: "Earth", es: "Tierra" }
        }
      },
      {
        ans: "c",
        q: {
          fr: "Quel est son totem ?",
          en: "What is its totem?",
          es: "¿Cuál es su tótem?"
        },
        options: {
          a: { fr: "Libellule", en: "Dragonfly", es: "Libélula" },
          b: { fr: "Phénix", en: "Phoenix", es: "Fénix" },
          c: { fr: "Arbre", en: "Tree", es: "Árbol" },
          d: { fr: "Sirène", en: "Mermaid", es: "Sirena" }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Quel est son nombre-guide ?",
          en: "What is its guide-number?",
          es: "¿Cuál es su número-guía?"
        },
        options: {
          a: { fr: "4", en: "4", es: "4" },
          b: { fr: "6", en: "6", es: "6" },
          c: { fr: "11", en: "11", es: "11" },
          d: { fr: "22", en: "22", es: "22" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Le segment « Alio- » renvoie à :",
          en: "The segment “Alio-” refers to:",
          es: "El segmento « Alio- » remite a:"
        },
        options: {
          a: { fr: "L’identique", en: "The identical", es: "Lo idéntico" },
          b: { fr: "L’autre, le différent", en: "The other, the different", es: "Lo otro, lo diferente" },
          c: { fr: "Le perdu", en: "The lost", es: "Lo perdido" },
          d: { fr: "Le chiffré", en: "The coded", es: "Lo cifrado" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "L’Aliœvolution insiste sur :",
          en: "Aliœvolution emphasizes:",
          es: "Aliœvolution insiste en:"
        },
        options: {
          a: { fr: "Une transformation sans ancrage", en: "Transformation without anchoring", es: "Transformación sin anclaje" },
          b: { fr: "Une transformation avec ancrage fort", en: "Transformation with strong anchoring", es: "Transformación con fuerte anclaje" },
          c: { fr: "Le rejet de l’évolution", en: "A rejection of evolution", es: "El rechazo de la evolución" },
          d: { fr: "Le seul passé", en: "Only the past", es: "Solo el pasado" }
        }
      },
      {
        ans: "c",
        q: {
          fr: "Pourquoi l’Arbre ?",
          en: "Why the Tree?",
          es: "¿Por qué el Árbol?"
        },
        options: {
          a: { fr: "Parce qu’il flotte", en: "Because it floats", es: "Porque flota" },
          b: { fr: "Parce qu’il est sans racines", en: "Because it is rootless", es: "Porque no tiene raíces" },
          c: { fr: "Parce qu’il joint enracinement et croissance vers l’autre", en: "Because it joins rooting with growth toward the other", es: "Porque une enraizamiento y crecimiento hacia el otro" },
          d: { fr: "Parce qu’il remplace l’eau", en: "Because it replaces water", es: "Porque reemplaza el agua" }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Ce pilier est qualifié comme :",
          en: "This pillar is qualified as:",
          es: "Este pilar es calificado como:"
        },
        options: {
          a: { fr: "Évolution dans le Temps", en: "Evolution in Time", es: "Evolución en el Tiempo" },
          b: { fr: "Fin de la création", en: "End of creation", es: "Fin de la creación" },
          c: { fr: "Suppression des différences", en: "Suppression of differences", es: "Supresión de las diferencias" },
          d: { fr: "Négation de l’altérité", en: "Negation of alterity", es: "Negación de la alteridad" }
        }
      },
      {
        ans: "a",
        q: {
          fr: "L’Aliœvolution permet de :",
          en: "Aliœvolution makes it possible to:",
          es: "Aliœvolution permite:"
        },
        options: {
          a: { fr: "Naviguer sans se perdre", en: "Navigate without getting lost", es: "Navegar sin perderse" },
          b: { fr: "Refuser le changement", en: "Refuse change", es: "Rechazar el cambio" },
          c: { fr: "Dissoudre l’identité", en: "Dissolve identity", es: "Disolver la identidad" },
          d: { fr: "Clore l’Organon posœnnoïal", en: "Close the Organon posœnnoïal", es: "Cerrar el Organon posœnnoïal" }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Elle vient surtout :",
          en: "It chiefly comes to:",
          es: "Viene sobre todo a:"
        },
        options: {
          a: { fr: "Ancrer la dynamique dans la durée et l’altérité", en: "Anchor the dynamic in duration and alterity", es: "Anclar la dinámica en la duración y la alteridad" },
          b: { fr: "Remplacer les Outils", en: "Replace the Outils", es: "Reemplazar las Outils" },
          c: { fr: "Supprimer la Katûvýs", en: "Suppress Katûvýs", es: "Suprimir Katûvýs" },
          d: { fr: "Contraindre RéZonans", en: "Constrain RéZonans", es: "Restringir RéZonans" }
        }
      }
    ]
  };

  function getUI(lang) {
    return UI[lang] || UI.fr;
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  function applySectionTabs(root, lang, sectionKey) {
    var ui = getUI(lang);
    var nav = root.querySelector("[data-po-section-tabs]");
    if (nav) nav.setAttribute("aria-label", ui.sections_aria);

    var labels = root.querySelectorAll("[data-po-section-label]");
    for (var i = 0; i < labels.length; i++) {
      var key = labels[i].getAttribute("data-po-section-label");
      setText(labels[i], ui.tabs[key] || key);
    }

    var buttons = root.querySelectorAll("[data-pilier]");
    for (var j = 0; j < buttons.length; j++) {
      var isActive = buttons[j].getAttribute("data-pilier") === sectionKey;
      if (isActive) buttons[j].classList.add("active");
      else buttons[j].classList.remove("active");
    }
  }

  function clearWarn(root) {
    var list = root.querySelector("#questionsList");
    if (list) {
      var warns = list.querySelectorAll(".warn");
      for (var i = 0; i < warns.length; i++) warns[i].classList.remove("warn");
    }
    var warn = root.querySelector("#pillars-warning");
    if (warn) warn.classList.add("hidden");
  }

  function clearFeedback(root) {
    var result = root.querySelector("#resultat");
    var answersBox = root.querySelector("#reponsesBox");
    var answersList = root.querySelector("#reponsesList");

    if (result) result.innerHTML = "";
    if (answersBox) answersBox.classList.add("hidden");
    if (answersList) {
      answersList.classList.add("hidden");
      answersList.innerHTML = "";
    }

    root.dataset.submitted = "0";
    clearWarn(root);
  }

  function collectSelections(root, sectionKey) {
    var out = {};
    var bank = BANK[sectionKey] || [];
    for (var i = 0; i < bank.length; i++) {
      var qid = "p" + (i + 1);
      var checked = root.querySelector('input[name="' + qid + '"]:checked');
      if (checked) out[qid] = checked.value;
    }
    return out;
  }

  function firstUnanswered(root, total) {
    for (var i = 1; i <= total; i++) {
      var name = "p" + i;
      if (!root.querySelector('input[name="' + name + '"]:checked')) return i;
    }
    return 0;
  }

  function applyFrame(root, lang, sectionKey) {
    var ui = getUI(lang);
    var sec = ui.sections[sectionKey] || ui.sections.rezonans;

    setImg(root.querySelector('[data-po-slot="title_img"]'), ui.title_img);
    setText(root.querySelector('[data-po-slot="title"]'), sec.title);
    setText(root.querySelector('[data-po-slot="kicker"]'), sec.kicker);
    setText(root.querySelector('[data-po-slot="submit_cta"]'), ui.submit_cta);
    setText(root.querySelector('[data-po-slot="warning_incomplete"]'), ui.warning_incomplete);
    setText(root.querySelector('[data-po-slot="toggle_answers_show"]'), ui.toggle_answers_show);
    setText(root.querySelector('[data-po-slot="cta_translate"]'), ui.cta_translate);

    var langbar = root.querySelector("[data-po-langbar]");
    if (langbar) langbar.setAttribute("aria-label", ui.langbar_aria);

    applyLangbar(root, lang);
    applySectionTabs(root, lang, sectionKey);
  }

  function renderQuestions(root, sectionKey, lang, preservedSelections) {
    var list = root.querySelector("#questionsList");
    if (!list) return;

    var bank = BANK[sectionKey] || [];
    list.innerHTML = "";

    for (var i = 0; i < bank.length; i++) {
      var item = bank[i];
      var qid = "p" + (i + 1);
      var qText = item.q[lang] || item.q.fr;
      var li = document.createElement("li");

      var html = '<p>' + protectLexiconInHTML(qText) + "</p>";
      ["a", "b", "c", "d"].forEach(function (key) {
        var opt = item.options[key][lang] || item.options[key].fr;
        html += '<label><input type="radio" name="' + qid + '" value="' + key + '"> ' +
          protectLexiconInHTML(opt) + "</label>";
      });

      li.innerHTML = html;
      list.appendChild(li);

      if (preservedSelections && preservedSelections[qid]) {
        var radio = li.querySelector('input[value="' + preservedSelections[qid] + '"]');
        if (radio) radio.checked = true;
      }
    }
  }

  function renderSection(root, sectionKey, lang, preservedSelections) {
    var safeLang = normLang(lang) || "fr";
    var safeSection = BANK[sectionKey] ? sectionKey : "rezonans";

    root.dataset.currentSection = safeSection;
    applyFrame(root, safeLang, safeSection);
    renderQuestions(root, safeSection, safeLang, preservedSelections || null);
    clearFeedback(root);
  }

  function validateSection(root) {
    var lang = getLang();
    var ui = getUI(lang);
    var sectionKey = root.dataset.currentSection || "rezonans";
    var bank = BANK[sectionKey] || [];
    var total = bank.length;
    var missingIndex = firstUnanswered(root, total);

    clearWarn(root);

    if (missingIndex) {
      var list = root.querySelector("#questionsList");
      var li = list && list.children[missingIndex - 1];
      var warn = root.querySelector("#pillars-warning");

      if (li) {
        li.classList.add("warn");
        try {
          li.scrollIntoView({ behavior: "smooth", block: "center" });
        } catch (e) {}
      }

      if (warn) warn.classList.remove("hidden");
      return;
    }

    var score = 0;
    var bonnes = [];

    for (var i = 0; i < bank.length; i++) {
      var item = bank[i];
      var qid = "p" + (i + 1);
      var checked = root.querySelector('input[name="' + qid + '"]:checked');

      if (checked && checked.value === item.ans) score++;

      var good = item.options[item.ans][lang] || item.options[item.ans].fr;
      bonnes.push("<li>" + protectLexiconInHTML(good) + "</li>");
    }

    var result = root.querySelector("#resultat");
    var answersBox = root.querySelector("#reponsesBox");
    var answersList = root.querySelector("#reponsesList");
    var toggle = root.querySelector("#toggleAnswers");

    if (result) result.innerHTML = ui.scoreText(score, total);
    if (answersBox) answersBox.classList.remove("hidden");
    if (answersList) {
      answersList.innerHTML = "<ol>" + bonnes.join("") + "</ol>";
      answersList.classList.add("hidden");
    }
    if (toggle) toggle.textContent = ui.toggle_answers_show;

    if (root.dataset.submitted !== "1") {
      bump("piliers." + sectionKey);
      root.dataset.submitted = "1";
    }
  }

  function toggleAnswers(root) {
    var lang = getLang();
    var ui = getUI(lang);
    var answersBox = root.querySelector("#reponsesBox");
    var answersList = root.querySelector("#reponsesList");
    var toggle = root.querySelector("#toggleAnswers");

    if (!answersBox || !answersList || !toggle) return;
    if (answersBox.classList.contains("hidden")) return;

    answersList.classList.toggle("hidden");
    toggle.textContent = answersList.classList.contains("hidden")
      ? ui.toggle_answers_show
      : ui.toggle_answers_hide;
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute("translate", "no");
    root.classList.add("notranslate");

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope) {
      scope.setAttribute("translate", "no");
      scope.classList.add("notranslate");
    }
  }

  function bindActions(root) {
    if (!root || root.__poPillarsQuizBound) return;
    root.__poPillarsQuizBound = true;

    var langButtons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < langButtons.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          setLang(btn.getAttribute("data-po-lang"));
        });
      })(langButtons[i]);
    }

    var sectionButtons = root.querySelectorAll("[data-pilier]");
    for (var j = 0; j < sectionButtons.length; j++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          renderSection(root, btn.getAttribute("data-pilier"), getLang(), null);
        });
      })(sectionButtons[j]);
    }

    var submit = root.querySelector("#pillars-submit");
    if (submit) {
      submit.addEventListener("click", function () {
        validateSection(root);
      });
    }

    var toggle = root.querySelector("#toggleAnswers");
    if (toggle) {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        toggleAnswers(root);
      });
    }

    var list = root.querySelector("#questionsList");
    if (list) {
      list.addEventListener("change", function () {
        clearWarn(root);
      });
    }
  }

  function setLang(lang) {
    var safeLang = normLang(lang) || "fr";
    storeLang(safeLang);
    syncDocumentLang(safeLang);

    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var sectionKey = root.dataset.currentSection || "rezonans";
      var preservedSelections = collectSelections(root, sectionKey);
      renderSection(root, sectionKey, safeLang, preservedSelections);
    }

    notifyLocaleChanged();
    return safeLang;
  }

  function initOne(root) {
    if (!root || root.__poPillarsQuizInit) return;
    root.__poPillarsQuizInit = true;

    lockTranslation(root);
    bindActions(root);

    var defaultSection = root.getAttribute("data-po-default-section") || "rezonans";
    renderSection(root, defaultSection, getLang(), null);
  }

  function init() {
    syncDocumentLang(getLang());
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
  }

  window.PoPillarsQuizTextsFR_EN_ES_20260321 = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    renderSection: renderSection,
    protectLexiconInHTML: protectLexiconInHTML
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  window.PosoMini = window.PosoMini || {};
  window.PosoMini.bump = bump;
  window.PosoMini.loadKey = function () { return COUNTER_KEY; };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();